import React from 'react'
import { Link } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import { LazyImage } from '../Common'
import { BannerField, BannerProps } from './banner.props'
import { useBanner } from '@sentecacommerce-theme/lib'

export const Banner = (props: BannerProps) => {
  const { images } = props

  const banner = useBanner<BannerField>(images)

  const {
    mobileImage,
    url,
    header,
    imageWidth,
    imageHeight,
    image,
    mobileImageHeight,
    mobileImageWidth,
  } = banner || {}

  if (!banner) return null

  const hasMobileImage = Boolean(mobileImage)
  const desktopClass = hasMobileImage ? 'd-none d-lg-block' : 'd-block'

  return (
    <Container>
      <Link href={url ?? ''} passHref>
        <a aria-label={header || props?.default?.ariaLabel}>
          <div className={desktopClass}>
            <LazyImage
              width={imageWidth}
              height={imageHeight}
              src={image ?? ''}
              alt={header || props?.default?.alt} // TODO: fallback
            />
          </div>
          {hasMobileImage && (
            <div className="d-block d-lg-none">
              <LazyImage
                width={mobileImageWidth}
                height={mobileImageHeight}
                src={mobileImage as string}
                alt={header || props?.default?.alt} // TODO: fallback
              />
            </div>
          )}
        </a>
      </Link>

      {header && (
        <figcaption>
          <Title>{header}</Title>
        </figcaption>
      )}
    </Container>
  )
}

const Title = styled.h2.attrs({
  'data-blogger': '',
  className: 'd-flex align-items-center justify-content-center',
})`
  position: absolute;
  width: 100%;
  text-align: center;
  transition: color 0.15s ease-in-out;
  color: ${({ theme }) => theme.palette.secondary};
  background: rgba(0, 0, 0, 0.4);
  height: 10rem;
  z-index: 1;
  pointer-events: none;
  bottom: 0;

  text-shadow: 0.1rem 0.1rem 0.1rem rgba(34, 34, 34, 0.5);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm.max}) {
    font-size: 2rem;
    height: 8rem;
  }
`

const Container = styled.figure`
  position: relative;

  &:hover h2 {
    color: ${({ theme }) => theme.palette.surfCrest};
  }
`
